import { useDashboardRouter as useRouter } from "@/hooks/useDashboardRouter";
import { useActiveGithubOrgForUserNonSuspense } from "@/hooks/useConnectedGithubOrgs";

/**
 * Gates the org-wide Network Monitoring page (sidebar entry + route).
 *
 * Deliberately separate from `network_dashboard_enabled` (the per-job Network
 * tab) so the global surface can roll out independently.
 *
 * Resolution order:
 * 1. `?global_network_monitoring=0|1` query override (any environment).
 * 2. Superusers always see it, so support can inspect any org's egress.
 * 3. The per-installation `global_network_monitoring_enabled` flag for the
 *    active org. Enable per org via `php artisan feature-flag:rollout`.
 */
export function useGlobalNetworkMonitoringEnabled() {
  const pageRouter = useRouter();
  const param = pageRouter.query.global_network_monitoring;
  const {
    globalNetworkMonitoringEnabled
  } = useActiveGithubOrgForUserNonSuspense();
  if (param === "0" || param === "false") {
    return false;
  }
  if (param === "1" || param === "true") {
    return true;
  }
  return globalNetworkMonitoringEnabled;
}